import { useRef } from 'react'
import { resolveComponentVariant } from '../common/componentContract'
import styles from './Patterns.module.css'

// renderItemActions(item, { selected, index }) renders per-item controls (a checkbox, a quick
// action) beside the option rather than inside it: an option must not
// contain interactive descendants, and a click on them must not select.
export function CatalogGrid({ items = [], getKey = (item) => item.id, renderItem, renderItemActions, selectedKeys = [], onSelectionChange, multiple = false, density = 'comfortable', columns = 3, label = 'Catalog', virtualizer, className = '' }) {
  const refs = useRef([])
  const selected = new Set(selectedKeys)
  const resolvedDensity = resolveComponentVariant('CatalogGrid density', density, ['dense', 'comfortable'], 'comfortable')
  const visibleItems = virtualizer?.(items) || items
  const select = (key) => {
    let next
    if (multiple) {
      next = new Set(selected)
      if (next.has(key)) next.delete(key); else next.add(key)
    } else next = new Set([key])
    onSelectionChange?.([...next])
  }
  return (
    <div className={`${styles.catalog} ${resolvedDensity === 'dense' ? styles.catalogDense : ''} ${className}`.trim()} style={{ '--wf-catalog-columns': columns }} role="listbox" aria-label={label} aria-multiselectable={multiple || undefined}>
      {visibleItems.map((item, index) => {
        const key = getKey(item)
        const isSelected = selected.has(key)
        const option = (
          <div key={key} ref={(node) => { refs.current[index] = node }} className={`${styles.catalogItem} ${isSelected ? styles.catalogItemSelected : ''}`.trim()} role="option" aria-selected={isSelected} tabIndex={index === 0 || isSelected ? 0 : -1} onClick={() => select(key)} onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(key) }
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); refs.current[Math.min(visibleItems.length - 1, index + 1)]?.focus() }
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); refs.current[Math.max(0, index - 1)]?.focus() }
          }}>
            {renderItem(item, { selected: isSelected, index })}
          </div>
        )
        if (!renderItemActions) return option
        return (
          <div key={key} className={styles.catalogCell}>
            {option}
            <div className={styles.catalogItemActions}>{renderItemActions(item, { selected: isSelected, index })}</div>
          </div>
        )
      })}
    </div>
  )
}
